import React, { useEffect, useState } from 'react';
import axios from 'axios';

import {
  Routes,
  Route,
  Outlet,
} from "react-router-dom";

import {
  ThemeProvider,
  InputGroup,
  Form,
  Button
} from 'react-bootstrap';

import CardsGallery from './CardsGallery';
import CardInfo from './CardInfo';
import CheckoutPage from './CheckoutPage';

import SearchResults from './CardsGallery/SearchResults';

import './App.scss';

const App = () => {
  const [isSearching, setIsSearching] = useState(false);
  const [searchString, setSearchString] = useState('');
  const [searchInputValue, setSearchInputValue] = useState('');
  const [clientCountryCode, setClientCountryCode] = useState('');

  useEffect(() => {
    axios.get('https://extreme-ip-lookup.com/json/?key=ylGRmUa4ilbXDLs4Y0BR')
      .then((data) => {
        setClientCountryCode(data?.data?.countryCode);
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    if (!searchString.length) return;
    // console.log(searchInputValue)
    setIsSearching(true)
  }, [searchString]);

  const searchCards = () => {
    // console.log(searchString)
    setSearchString(searchInputValue);
  };

  const stopSearching = () => {
    setIsSearching(false);
    setSearchString('');
    document.querySelector('#searchInput').value = '';
  };

  return (    
    <div className="main-container">
      <Routes>
        <Route
          path="/"
          element={
            <div
              style={{
                position: 'relative',
                height: '100%'
              }}
            >
              <h6 className="main-header px-3 py-3">
                BUY GIFT CARDS WITH CRYPTO
              </h6>

              <InputGroup className="search-input-group px-3 pb-3">
                <Form.Control
                  placeholder="Search for gift card..."
                  aria-label="Search for gift card..."
                  aria-describedby="basic-addon2"
                  id="searchInput"
                  onChange={e => setSearchInputValue(e.target.value)}
                />
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" className="bi bi-search" viewBox="0 0 16 16">
                  <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                </svg>
                {isSearching && (
                  <Button variant="gcn-primary" id="button-addon2" onClick={stopSearching}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#141831" className="bi bi-x-circle-fill" viewBox="0 0 16 16">
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"/>
                    </svg>
                  </Button>
                )}
                <Button variant="gcn-primary" id="button-addon" onClick={searchCards}>
                  GO
                </Button>
              </InputGroup>

              {isSearching ? (
                <SearchResults
                  searchString={searchString}
                  clientCountryCode={clientCountryCode}
                />
              ) : (
                <CardsGallery clientCountryCode={clientCountryCode} />
              )}

              <Outlet />
            </div>
          }
        >
          <Route
            path="card/:productCode"
            element={
              <CardInfo />
            }
          >
            <Route
              path="checkout"
              element={
                <CheckoutPage />
              }
            /> 
          </Route>
          {/* <Route
            path="search"
            element={
              <CardInfo
                // height={innerContentHeight}
              />
            }
          /> */}
        </Route>
      </Routes>
    </div>
  );
};

export default App;
